import { ReactNode } from 'react';

import { PAGE_TITLE, SERVICE_SUBPAGE_TITLE } from '../core/portal/consts';

import { PORTAL_PATH, NO_AUTH_PATH, PROFILE_CREATION_PATH } from './paths';
import { CheckIfUserHasPortalPrivilege } from '../common/client-status/interfaces';

type Render = () => ReactNode;

export interface CommonRoute {
  render: Render;
  isRedirect: boolean;
}

export const guardIsRedirect = <T>(route: CommonRoute | T): route is CommonRoute =>
  (route as CommonRoute).isRedirect !== undefined;

export interface ProfileCreationRoute {
  path: PROFILE_CREATION_PATH;
  render: Render;
}

export interface PortalRoute {
  path: PORTAL_PATH;
  portalPrivilegeVerification: (verify: CheckIfUserHasPortalPrivilege) => boolean;
  render: Render;
  title: PAGE_TITLE;
}

export interface PortalWithSubpagesRoute {
  path: PORTAL_PATH;
  subtitle: SERVICE_SUBPAGE_TITLE;
  title: PAGE_TITLE;
}

export interface NoAuthRoute {
  exact: boolean;
  path: NO_AUTH_PATH;
  render: Render;
}
